import styled from '@emotion/styled';
import { colors, heapTrack } from '@modernanimal/common';
import posthog from 'posthog-js';
import useBreakpoint from 'use-breakpoint';

import PrimaryButton from '../components/PrimaryButton';
import { BREAKPOINTS } from '../helpers';

const NextStepButton = (props: {
    disabled: boolean;
    goToNextStep: ()=> void;
    onClick: ()=> void;
}) => {
    const { disabled, goToNextStep, onClick } = props;

    const { breakpoint } = useBreakpoint(BREAKPOINTS, 'desktop');
    const isMobile = breakpoint === 'mobile';

    const handleNext = () => {
        onClick();
        heapTrack('Web Booking - Select Appointment View - Next Button Clicked');
        posthog.capture('web_booking_click', { screen: 'SelectAppointment', action: 'NextButtonClicked' });
        goToNextStep();
    };

    return (
        <NextButtonContainer isMobile={isMobile}>
            <PrimaryButton
                id="select-appointment-button"
                color="periwinkle"
                onClick={handleNext}
                disabled={disabled}
            >
                Next
            </PrimaryButton>
        </NextButtonContainer>
    );
};

export default NextStepButton;

const NextButtonContainer = styled.div<{ isMobile: boolean }>`
    display: flex;
    position: ${({ isMobile }) => (isMobile ? 'sticky' : 'static')};
    bottom: 0px;
    background-color: ${({ isMobile }) => (isMobile ? 'transparent !important' : colors.WHITE)};
    ${({ isMobile }) => (isMobile ? 'padding: 16px 0 5% 0' : 'padding: 16px 0 32px 0')};
    ${({ isMobile }) => isMobile && `
        flex-direction: row-reverse; 
        
        button {
            width: unset; 
            height: unset;
            padding: 16px 32px;
            border-radius: 40px;
            position: relative;
            right: -3%;
        }   
    `}
`;
